import React, { useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
// import {useForm} from "react-hook-form";
import applicationComander from "../../../store/commanders/application.comander";
import { useSelector } from "react-redux";

import {
  Box,
  Button,
  Divider,
  Group,
  PasswordInput,
  Space,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { validateEmail } from "../../../helpers/form.validators";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { GoogleButton } from "../../../components/google/google.button";
// import LoginRightMessage from "./login.right.message";

export default function LoginPage() {
  const appState = useSelector((state: any) => state.application);
  const existingUser = useSelector((state: any) => state.account.userData);
  const history = useHistory();

  const onSubmit = (data) =>
    applicationComander.cmd_login(data.email.toLowerCase(), data.password);

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },

    validate: {
      email: validateEmail,
    },
  });

  useEffect(() => {
    if (existingUser && existingUser.username) {
      form.setValues({ email: existingUser.email });
    }
  }, [existingUser?.username]);


  if (!appState.authorise) {
    // if (!appState.loading && !process.env.REACT_APP_LOCAL) {
    //   window.location.href = process.env.REACT_APP_AUTH_URL;
    //   return <LoaderComponent loading overlayLoading={false}></LoaderComponent>;
    // }
    return (
      <div>
        <div className="auth-container-box">
          <div className="auth-split-layout">
            {/* Left side - Login Form */}
            <Box className="auth-form-section">
              <Title order={1} align={"center"} className="auth-title">
                Sign In to Your Account
              </Title>
              <Space h={"xl"}></Space>
              <GoogleButton
                onClick={() => {
                  applicationComander.cmd_login_google();
                }}
              />
              <Divider
                label="Or continue with email"
                labelPosition="center"
                my="lg"
              />
              <Space h="xl" />
              <form
                onSubmit={form.onSubmit((values) => onSubmit(values))}
                className="u-w-100"
              >
                <TextInput
                  required
                  label="Email"
                  placeholder="your@email.com"
                  className="u-w-100"
                  {...form.getInputProps("email")}
                />
                <Space h="md" />
                <PasswordInput
                  required
                  label="Password"
                  placeholder="password"
                  className="u-w-100"
                  {...form.getInputProps("password")}
                />
                <Space h="xs" />
                <div>
                  <Text
                    size="sm"
                    align="right"
                    className="auth-link"
                    onClick={() =>
                      history.push(URL_PATHS.FORGOT_PASSWORD, { email: form.values.email })
                    }
                  >
                    Forgot Password
                  </Text>
                </div>
                <Group mt="lg" mb="sm">
                  <Button
                    size="lg"
                    type="submit"
                    className="u-w-100 auth-submit-button"
                  >
                    LOGIN
                  </Button>
                  <Button
                    size="lg"
                    variant="outline"
                    className="u-w-100 mobile-auth-button"
                    onClick={() => history.push(URL_PATHS.SIGNUP)}
                  >
                    SIGN UP
                  </Button>
                  <Space h={"sm"}></Space>
                </Group>
              </form>
            </Box>

            {/* Right side - Sign Up Prompt */}
            <Box className="auth-prompt-section">
              <div className="auth-prompt-content">
                <Text className="auth-prompt-title">Create an Account!</Text>
                <Text className="auth-prompt-description">
                  Sign up if you still don't have an account...
                </Text>
                <Button
                  variant="outline"
                  size="lg"
                  className="auth-prompt-button"
                  onClick={() => history.push(URL_PATHS.SIGNUP)}
                >
                  Sign Up
                </Button>
              </div>
            </Box>
          </div>
        </div>
      </div>
    );
  } else {
    return <Redirect to={URL_PATHS.APP} />;
  }
}
